































import {
  Component, Mixins,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import SocialModule from '@/store/modules/Social';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component({
  components: {

  },
})
export default class SocialView extends Mixins(
  ErrorHandleMixin,
) {
  SocialInstance = getModule(SocialModule, this.$store);

  social = {}

  data = ''

  async created() {
    this.FetchSocial();
  }

  async FetchSocial() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.SocialInstance.FetchSocial();
    this.data = this.SocialInstance.sociallList.social;
    if (res.code) {
      this.checkError(res);
    }
    this.GeneralInstance.toggleLoading(false);
  }

  async handleSocial() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.SocialInstance.EditSocial({ social: { ...this.social } });
    this.GeneralInstance.toggleLoading(false);
    if (res.code) {
      this.checkError(res);
    }
    this.social = '';
    this.FetchSocial();
  }
}
